// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"480":"cba2691c","826":"6aca8a87"}[chunkId] + ".chunk.js";
};